export default {
  brandColor1: '#8CC68B',
  complimentaryColor1: '#ffffff',
  brandColor2: '#8CC68B',
  complimentaryColor2: '#fff',
};
